import { AddNewButton } from 'Components/Buttons';
import { SITE_PAGES } from 'Config';
import { useDrawerContext } from 'Context';
import AdminLanding from 'Pages/Admin/AdminLanding';
import UserDetails from 'Pages/Admin/Users/UserDetails';
import UserListView from 'Pages/Admin/Users/UserListView';

const ManageUsersView = () => {
  const { openDrawer, closeDrawer } = useDrawerContext();

  let breadcrumb = [SITE_PAGES.MANAGE_USERS];

  let drawerContent = (
    <UserDetails editable hideToggle parentEditState={true} />
  );
  const onClick = () => {
    openDrawer({
      content: drawerContent,
      title: 'New User',
    });
  };

  let addNewButton = <AddNewButton buttonText='Add User' onClick={onClick} />;

  return (
    <AdminLanding breadcrumbs={breadcrumb}>
      <UserListView addNewUserButton={addNewButton} />
    </AdminLanding>
  );
};

export default ManageUsersView;
